// ----------------------------------------------------------------------------
// Snippet: Social Sharing
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_social-sharing.scss';